<template>
  <div class="cm-order">
    <div class="p-main-content">
      <div class="c-mtop">
        <p class="m-title">订单支付</p>
      </div>
      <div class="main-text">
        <div>
          <p class="m-f-title">商品信息</p>
          <div class="order-msg">
            <div class="fl">
              <img src="" alt="">
            </div>
            <div class="fr">
              <p>订单编号&nbsp;:&nbsp;{{order.code}}</p>
              <p class="order-time">订单日期&nbsp;:&nbsp;{{order.orderDate}} <span>￥{{order.amount}}</span></p>
              <p class="lx-pay">交付方式&nbsp;:&nbsp;{{deliveryTypeDes}}</p>
            </div>
          </div>
          <hr>
          <div class="paytype">
            <p>支付方式</p>
            <ul>
              <li :class="item.active" v-for="(item,index) in paytype" :key="`paytype${index}`" @click="changepaytype(item)"><span :class="item.class"></span></li>
            </ul>
          </div>
          <hr>
          <div class="payyhq" v-if="order.vouchers.length>0">
            <p>使用优惠券<i class="el-icon-arrow-up"></i></p>
            <ul>
              <li v-for="(voucher,index) in order.vouchers" :class="voucher.active" :key="index" @click="changeyhq(index)">
                <span class="price">￥{{ voucher.amount }}</span>
                <br>
                <span>至{{ voucher.endDate }}</span>
              </li>
            </ul>
          </div>
          <hr v-if="order.vouchers.length>0">
          <div class="jz-msg">
            <p><span>订单总金额&nbsp;:&nbsp;</span><span class="s-r">￥{{order.amount}}</span></p>
            <p><span>优惠券抵扣&nbsp;:&nbsp;</span><span class="s-r">-￥{{discount}}</span></p>
            <p><span>应付&nbsp;:&nbsp;</span><span class="s-r countprice">￥{{payAmount}}</span></p>
            <p><el-button type="danger" round @click="paySubmit">立即支付</el-button></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'orderpay',
  components: {
  },
  data () {
    return {
      order: {
        code: '',
        orderDate: '',
        amount: '',
        deliveryType: '',
        vouchers: []
      },
      deliveryTypeDes: '',
      selectedVouchers: [],
      discount: 0,
      paytype: [
        {
          type: 'zhifubao',
          active: 'active',
          class: 'taobao'
        },
        {
          type: 'weixin',
          active: '',
          class: 'weixin'
        }
      ]
    }
  },
  mounted() {
    // 取出待支付的订单标识
    let id = this.$route.query.id
    console.log(`订单标识：${id}`)
    // 根据订单标识查询订单信息
    this.sapost(`/dmc/order/${id}`, '', r => {
      console.log(r.data)
      let result = r.data
      if (result.result_code === 'SUCCESS') {
        this.order = result
        console.log('订单信息查询成功！')
      } else {
        this.$message.warning(result.result_msg)
        this.$router.back()
      }
    })
  },
  methods: {
    changepaytype(p) {
      this.paytype.forEach((o) => {
        if (o.type === p.type) {
          o.active = 'active'
        } else {
          o.active = ''
        }
      })
    },
    changeyhq (p) {
      this.order.vouchers.forEach((voucher, index) => {
        if (p === index) {
          // 更改选中的样式
          if (voucher.active === '' || voucher.active === undefined) {
            if (this.payAmount === 0) {
              return
            }
            voucher.active = 'active'
            this.discount += parseFloat(voucher.amount)
            this.selectedVouchers.push(voucher)
          } else {
            voucher.active = ''
            this.discount = this.discount - parseFloat(voucher.amount) > 0 ? this.discount - parseFloat(voucher.amount) : 0
            this.selectedVouchers.splice(this.selectedVouchers.indexOf(voucher), 1)
          }
          // 强制更新页面
          this.$forceUpdate()
        }
      })
    },
    paySubmit() {
      var payType = this.paytype.find(item => item.active === 'active')
      var voucherIds = []
      this.selectedVouchers.forEach(voucher => {
        voucherIds.push(voucher.voucherAccountId)
      })
      let order = {
        orderId: this.$route.query.id,
        payType: payType.type,
        amountOfPay: this.payAmount,
        voucherIds: voucherIds
      }
      this.sapost('/dmc/order/orderPay', order, r => {
        let {returnCode, returnMsg, payType, url} = r.data
        if (returnCode === 'FAIL') {
          this.$message.warning(returnMsg)
        } else {
          if (payType !== 'daijinquan') {
            window.location.href = url
          } else {
            this.$router.push({
              path: '/order/paySuccess',
              query: {
                orderType: this.order.orderType + ''
              }
            })
          }
        }
      })
    }
  },
  computed: {
    deliveryType() {
      return this.order.deliveryType
    },
    payAmount() {
      return this.order.amount * 1 - this.discount * 1 <= 0 ? 0 : (this.order.amount * 1 - this.discount * 1).toFixed(2)
    },
    vouchers() {
      return this.order.vouchers
    }
  },
  watch: {
    deliveryType(value) {
      if (value === '0') {
        this.deliveryTypeDes = '下载'
      }
      if (value === '1') {
        this.deliveryTypeDes = '推送'
      }
      if (value === '2') {
        this.deliveryTypeDes = '离线邮寄'
      }
      if (value === '3') {
        this.deliveryTypeDes = '服务器接收'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.cm-order{
  .p-main-content {
    background-color: #f8fafc;
    .c-mtop{
      height: 120px;
      background: repeating-linear-gradient(60deg,
              #d0d5d9, #d0d5d9 55px,
              #e2e6e9 0, #e2e6e9 110px);
      margin-bottom: 14px;
      position: relative;
      z-index: 9;
      .m-title{
        width: 1100px;
        margin: 0 auto;
        padding-left: 35px;
        font-size: 24px;
        padding-top: 25px;
        text-align: left;
      }
    }
    .main-text{
      width: 1040px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      padding: 30px;
      background-color: white;
      top: -70px;
      z-index: 99;
      border-radius: 5px;
      margin-bottom: -40px;
      box-shadow: 0 0 8px #ccc;
      .m-f-title{
        margin-left: 10px;
        font-size: 14px;
        text-align: left;
        span{
          float: right;
          color: #b6b9bc;
          font-size: 12px;
        }
      }
      .order-msg{
        overflow: hidden;
        padding: 15px;
        background-color:#f3f5f7;
        margin-top: 20px;
        text-align: left;
        .fl{
          float: left;
          width: 200px;
          line-height: 0;
          img{
            display: inline-block;
            width: 200px;
            height: 120px;
            border: 0;
            background-color: #cacaca;
          }
        }
        .fr{
          margin-left: 220px;
          line-height: 2em;
          .order-time{
            font-size: 12px;
            color: #cacaca;
            span{
              margin-left: 300px;
              color: red;
              font-size: 14px;
              vertical-align: text-top;
            }
          }
          .lx-pay{
            color: red;
          }
        }
      }
      hr{
        background-color: #cacaca;
        border: none;
        height: 1px;
        margin: 20px 0 14px 0px;
      }
      .jz-msg{
        float: right;
        text-align: right;
        font-size: 14px;
        line-height: 2.5em;
        .s-r{
          display: inline-block;
          width: 140px;
          text-align: right;
        }
        .gm-user{
          color:#b6b9bc;
        }
        .countprice{
          color: red;
          font-size: 24px;
          font-weight: 600;
        }
        button{
          margin-top: 10px;
        }
      }
      .paytype{
        padding: 0 10px;
        font-size: 14px;
        text-align: left;
        ul{
          padding-top: 10px;
          overflow: hidden;
          li{
            float: left;
            margin: 15px 15px 0 0;
            span{
              display: inline-block;
              width: 192px;
              height: 92px;
              border-radius: 5px;
              overflow: hidden;
              cursor: pointer;
            }
            span.taobao {
              background: url('../assets/img/paytype.png') 0px -20px;
            }
            span.weixin {
              background: url('../assets/img/paytype.png') -212px -20px;
            }
          }
          .active{
            span.taobao{
              background: url('../assets/img/paytype.png') 0px 90px;
            }
            span.weixin {
              background: url('../assets/img/paytype.png') -212px 90px;
            }
          }
        }
      }
      .payyhq{
        padding: 0 10px;
        font-size: 14px;
        text-align: left;
        i{
          margin-left: 25px;
          color: #b6b9bc;
        }
        span.fr{
          float: right;
          color: #b6b9bc;
          font-size: 12px;
        }
        ul{
          overflow: hidden;
          padding-top: 10px;
          li{
            float: left;
            margin: 15px 26px 0 8px;
            width: 170px;
            height: 110px;
            color: #fff;
            text-align: left;
            cursor: pointer;
            background: url('../assets/img/paytype.png') -435px 0px;
            .price{
              color: #f01414;
              font-size: 24px;
            }
            span{
              font-size: 12px;
              padding-left: 20px;
              line-height: 2.8em;
            }
          }
          .active{
             background: url('../assets/img/paytype.png') -435px 110px;
            span{
              color: #fff;
              .price{
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/OrderPay.vue